import { render, staticRenderFns } from "./Iiko.vue?vue&type=template&id=761ea8c3&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./Iiko.vue?vue&type=script&lang=js&"
export * from "./Iiko.vue?vue&type=script&lang=js&"
import style0 from "./Iiko.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Iiko.vue?vue&type=style&index=1&id=761ea8c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761ea8c3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
